import React from "react"
import Layout from "src/components/Layout"
import LinkedButton from "src/components/buttons/LinkedButton"
import * as styles from "src/styles/team.module.scss"

export default function Donate() {
  return (
    <Layout>
      <div className="container">
        <h1 className="heading">Donations</h1>
        <p>
          Your valuble donations will be deposited in the society registered
          savings account.
        </p>
        <p>Help us help to bring technology education to rural Sri Lanka.</p>
        <h2 className="heading">Nenathambara Society Bank Details</h2>
        <p>
          Account Number : 100714024138 <br />
          Bank : Sampath Bank <br />
          Branch : Kandy Super
        </p>
        <div className={styles.join_us}>
          <h2>Having Issues with donations?</h2>
          <LinkedButton path="/about" label="Contact Us" />
        </div>
      </div>
    </Layout>
  )
}
